var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.dialogVisiable && _vm.fileType === 'wpsFile')?_c('div',{staticClass:"custom-content-wps t-c"},[_c('iframe',{staticStyle:{"height":"100%"},attrs:{"id":"iframeWps","src":_vm.iframeSrc,"width":"100%","scrolling":"no","frameborder":"0"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }